import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  GrantTerm,
  GrantedArea,
  KSANCardNumberIssued,
  NameLowercase,
  Note,
  PersonalId,
  Regency,
  Sex,
  Team,
} from "./_fields";

type SecurityControlLongTermEvictTemplate = {
  unit: string;
  name: string;
  sex: string;
  personalId: number;
  regency: string;
  KSANCardNumberIssued: string;
  grantTerm: string;
  grantedArea: string;
  note: string;
};

export const securityControlLongTermEvictTemplate: TemplatesValue<SecurityControlLongTermEvictTemplate> =
  {
    fileName: "DanhSachNhanVienDaiHanGiaHan",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        ...Team,
        header: "Đơn vị",
      },
      NameLowercase,
      Sex,
      PersonalId,
      Regency,
      KSANCardNumberIssued,
      GrantTerm,
      {
        ...GrantedArea,
        header: "Khu vực được cấp",
      },
      Note,
    ],
    fields: [
      "unit",
      "name",
      "sex",
      "personalId",
      "regency",
      "KSANCardNumberIssued",
      "grantTerm",
      "grantedArea",
      "note",
    ],
  };
